var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import { Nav, UncontrolledAlert as Alert } from 'reactstrap';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import generateMenu, { ArrowLeft, ArrowRight } from './scrollable-menu-helpers';
import { slugify } from '../../app/general';
import { hasStaticHeader, smoothScrollTo } from '../../app/ui';
import withIframeStyle from '../../containers/WithIframeStyle';
import { getRestaurantMenuNavStyle } from '../../utils/iframe-style-helper';
import './restaurant-menu-nav.scss';
var getCategories = function (props) {
    var menu = props.menu;
    var categories = (menu || {}).categories;
    return { menu: menu, categories: categories };
};
var RestaurantMenuNav = /** @class */ (function (_super) {
    __extends(RestaurantMenuNav, _super);
    function RestaurantMenuNav(props) {
        var _this = _super.call(this, props) || this;
        _this.menuItems = [];
        _this.onSelect = function (key) {
            if (!key) {
                return;
            }
            var categories = getCategories(_this.props).categories;
            _this.setState({ selected: key.toString() });
            smoothScrollTo("#category-".concat(key), RestaurantMenuNav.calculateCategoryOffset());
            _this.menuItems = generateMenu(categories, key);
        };
        var categories = getCategories(props).categories;
        if (categories && categories.length && categories[0].name) {
            var selected = categories[0].name;
            _this.menuItems = generateMenu(categories, selected);
            _this.state = { selected: selected };
        }
        else {
            _this.state = { isEmptyMenu: true };
        }
        return _this;
    }
    RestaurantMenuNav.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeCategory !== nextProps.activeCategory) {
            this.setState({ selected: slugify(nextProps.activeCategory.name) });
        }
    };
    RestaurantMenuNav.calculateCategoryOffset = function () {
        var takeoutNav = document.querySelector('.takeout-nav');
        // @ts-ignore
        var takeoutNavHeight = (takeoutNav && takeoutNav.offsetHeight) || 0;
        var navbar = document.querySelector('.navbar');
        // @ts-ignore
        var navbarHeight = (navbar && navbar.offsetHeight) || 0;
        return navbarHeight + takeoutNavHeight;
    };
    RestaurantMenuNav.prototype.render = function () {
        var isInIframe = this.props.isInIframe;
        var isPrimaryHeader = isInIframe;
        var rootClassName = "takeout-nav-wrapper ".concat(isPrimaryHeader ? 'takeout-nav-wrapper--alone' : '');
        var style = isInIframe
            ? this.props.iframeStyle
            : hasStaticHeader()
                ? { top: 10 }
                : {};
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: rootClassName, style: style }, this.state.isEmptyMenu ? (this.renderEmptyMenuAlert()) : (React.createElement(Nav, { className: "takeout-nav" },
                React.createElement(ScrollMenu, { data: this.menuItems, arrowLeft: ArrowLeft, arrowRight: ArrowRight, selected: this.state.selected, onSelect: this.onSelect, alignCenter: false, hideArrows: true, hideSingleArrow: true, scrollToSelected: true, inertiaScrolling: true }))))));
    };
    RestaurantMenuNav.prototype.renderEmptyMenuAlert = function () {
        return (React.createElement(Alert, { color: "secondary", className: "mt-2" },
            React.createElement("div", null, "Brak dost\u0119pnych pozycji do zam\u00F3wienia."),
            React.createElement("div", null, "Menu restauracji jest nie wprowadzone, lub wszystkie produkty s\u0105 niedost\u0119pne.")));
    };
    RestaurantMenuNav.propTypes = {
        isInIframe: PropTypes.bool.isRequired,
        menu: PropTypes.object.isRequired,
    };
    RestaurantMenuNav.displayName = 'RestaurantMenuNav';
    return RestaurantMenuNav;
}(React.PureComponent));
export default withIframeStyle(RestaurantMenuNav, getRestaurantMenuNavStyle);
